<template>
    <div>
        <!-- Chi tiết hợp đồng -->
        <b-modal ref="modal-contract-detail" :centered="true" :scrollable="true" :title="title" class="modal-contract-detail" hide-footer
                 size="xl" @hide="onHide" @show="getListGift">

            <div class="d-block text-center">
                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                    <form class="form" @submit.prevent="handleSubmit(saveContract)">
                        <div class="row">
                            <div class="col-md-7 shadow">
                                <user-detail
                                    :branch="contract_detail.branch"
                                    :total_deposit_log="contract_detail.total_deposit_log"
                                    :center="contract_detail.center"
                                    :confirm="contract_detail.confirm"
                                    :customer="contract_detail.customer"
                                    :editBirthDate="editBirthDate"
                                    :editBranch="editBranch"
                                    :editEmail="editEmail"
                                    :editName="editName"
                                    :editPhone="editPhone"
                                    :is_disable_phone="disablePhone"
                                    :is_edutalk="is_edutalk"
                                    :total_paid="contract_detail.total_paid"
                                    :user="contract_detail.user"
                                    @changeEditBranch="changeEditBranch"
                                    @changeEditStatus="changeEditStatus"
                                ></user-detail>
                                <div v-if="showTuitionPayment" class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <el-select v-model="tuitionPayment" class="w-100"
                                                       placeholder="Hình thức đóng học phí"
                                                       @change="getListVouchers()">
                                                <el-option
                                                    v-for="item in tuitionPayments"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <button
                                                :disabled="!canAddMoreCourse"
                                                class="btn btn-success"
                                                type="button"
                                                @click="addCourse"
                                            >
                                                Thêm khóa học
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <course-class
                                        v-for="(course_info,index) in contract_detail.student_register_courses"
                                        :key="index"
                                        :branchs="branches"
                                        :center_classes="center_classes"
                                        :condition_courses="condition_courses"
                                        :contract="contract_detail"
                                        :course_info="course_info"
                                        :courses="availableCourses"
                                        :courses-refund="coursesRefund"
                                        :index="index"
                                        :is-transferred="is_transferred"
                                        class="col-md-6"
                                        @changeBranch="changeBranch"
                                        @deleteCourse="deleteCourse"
                                        @selectClass="selectClass"
                                        @selectCourse="selectCourse"
                                    >
                                    </course-class>
                                </div>
                                <div v-if="showMainClassSelect" class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>
                                                Lớp học chính
                                                <span class="text-danger">*</span>
                                            </label>
                                            <ValidationProvider
                                                v-slot="{ errors, classes }"
                                                name="Lớp học chính"
                                                rules="required"
                                                vid="deposit_refunds.main_class_id"
                                            >
                                                <el-select
                                                    v-model="contract_detail.deposit_refunds.main_class_id"
                                                    v-loading="mainClassLoading"
                                                    :class="classes"
                                                    class="w-100"
                                                    clearable
                                                    filterable
                                                    placeholder="Chọn lớp học chính đã đăng ký"
                                                >
                                                    <el-option
                                                        v-for="item in mainClassOptions"
                                                        :key="item.id"
                                                        :label="item.label"
                                                        :value="item.id"
                                                    />
                                                </el-select>
                                                <div class="fv-plugins-message-container">
                                                    <div class="fv-help-block">{{ errors[0] }}</div>
                                                </div>
                                                <small
                                                    v-if="!mainClassLoading && mainClassOptions.length === 0"
                                                    class="text-muted"
                                                >
                                                    Học viên chưa có lớp học chính nào đã đăng ký.
                                                </small>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <WarrantySelect :center-id="contract_detail.center_id" :services="warrantyServices"
                                    :disabled="false" :selected-id="contract_detail.service_id"
                                    @selected="setSelectedWarrantyService" />
                            </div>
                            <div class="col-md-5">
                                <payment-detail
                                    :contract="contract_detail"
                                    :course-price="coursePrice"
                                    :hide-course-price-edit="isCourseType77Contract"
                                    :courses-refund="coursesRefund"
                                    :gifts="listGift"
                                    :is-transferred="is_transferred"
                                    :is-withdraw-with-course="isWithdrawWithCourse"
                                    :promotion-for-contract="promotionForContract"
                                    :promotionTotal="promotionTotal"
                                    :promotions="promotions"
                                    :total-contract-amount="totalContractAmount"
                                    :total-course-refund-fee="totalCourseRefundFee"
                                    :total-course-register-fee="totalCourseRegisterFee"
                                    :total-destroy-fee="totalDestroyFee"
                                    :total-discount="totalDiscount"
                                    :total-promotion-after-transferred="totalPromotionAfterTransferred"
                                    :tuition-payment-id="tuitionPayment"
                                    :vouchers="vouchers"
                                    :vouchers-for-contract="vouchersForContract"
                                    @changeCoursePrice="changeCoursePrice"
                                    @changeDestroyFee="changeDestroyFee"
                                    @disableButtonSave="disableButtonSave"
                                    @removeContractPromotion="removeContractPromotion"
                                    @removeContractVoucher="removeContractVoucher"
                                    @showPromotions="showGift"
                                    @showVouchers="showVouchers"
                                >
                                </payment-detail>
                                <!-- <div class="gift-detail" v-if="gift_select && gift_select.description"> -->
                                <!-- <p class="ml-3 font-weight-bold">Quà tặng:</p> -->
                                <!-- <p class="ml-3 font-weight-bold">{{ gift_select.description }}</p> -->
                                <!-- </div> -->
                                <!-- Quà tặng -->
                                <div v-if="is_edutalk && gift_select && checkGiff" class="payment-detail pt-5 table-responsive">
                                  <div><h4 class="mb-3" style="font-weight: 700">Quà tặng</h4></div>
                                  <div
                                      v-for="gift in gift_select"
                                      :key="gift.id"
                                      class="d-flex align-items-center mb-2"
                                  >
                                    <i
                                        class="fas fa-minus-circle mr-2"
                                        style="cursor:pointer"
                                        @click="deleteGift(gift)"
                                    ></i>
                                    <div class="w-100">
                                      <b-button
                                          class="m-1 m-0 button_show_value"
                                          :id="`gift-${gift.id}`"
                                          v-b-toggle="`payment-gift-detail-${gift.id}`"
                                      >
                                        {{ gift.name }} <i class="fas fa-chevron-down"></i>
                                      </b-button>
                                      <b-collapse :id="`payment-gift-detail-${gift.id}`">
                                        <p v-html="gift.description" class="mt-3 pl-2 ml-3 font-weight-bold"></p>
                                      </b-collapse>
                                    </div>
                                  </div>
                                </div>
                                <div class="payment-information">
                                    <payment-information :gift-data="giftData"
                                                         :is_edutalk="is_edutalk"
                                                         :refund-data="refundData"
                                                         :subcontracts="contract_detail.subcontracts"></payment-information>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
            <footer class="modal-footer">
                <button class="btn btn-secondary" type="button" @click="hideModal">Hủy bỏ</button>
                <button :disabled="checkTotal" class="btn btn-success" type="button" @click="saveContract">Xác nhận
                </button>
            </footer>
            <b-button ref="show-gift-list" v-b-modal.list-promotions hidden size="lg">Open Third Modal</b-button>
            <b-button ref="show-vouchers-list" v-b-modal.list-vouchers hidden size="lg">Open Third Modal</b-button>
        </b-modal>
        <!-- Danh sách quà tặng -->
        <b-modal id="list-promotions"
                 ref="modal-list-promotions"
                 :centered="true"
                 :scrollable="true" hide-footer
                 noFade
                 size="lg"
                 title="Danh sách quà tặng">
            <list-gifts :gift-select="gift_select"
                        :gifts="listGift"
                        :id_promotion_disable="id_promotion_disable"
                        :vouchersForContract="vouchersForContract"
                        @cancelGift="cancelGift"
                        @pickGift="pickGift"
                        @setPromotionForContract="setPromotionForContract"
                        @setVoucherForContract="setVoucherForContract"
                        @showPromotionDetail="showPromotionDetail"
            ></list-gifts>
            <b-button ref="show-promotion-detail" v-b-modal.promotion-detail hidden size="sm">Open Third Modal
            </b-button>
        </b-modal>

        <!-- Danh sách voucher -->
        <b-modal id="list-vouchers" ref="modal-list-vouchers" :centered="true" :scrollable="true" hide-footer size="lg"
                 title="Danh sách voucher">
            <!--			<list-vouchers :vouchers="vouchers"-->
            <!--						   :id_voucher_disable="id_voucher_disable"-->
            <!--						   @showVoucherDetail="showVoucherDetail"-->
            <!--						   @setVoucherForContract="setVoucherForContract"-->
            <!--			>-->
            <!--			</list-vouchers>-->
            <div class="mb-2 pb-2 ml-0 mr-0 w-100">
              <el-input class="w-100" @input="queryByKeywordDebounced" placeholder="Nhập tên,id voucher, quà tặng" v-model="keyword" clearable></el-input>
            </div>
            <div v-if="allCode[FLASH_SALE]?.length">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình Flash sale</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#FF8C22'"
                               :loading_voucher="loading_voucher"
                               :id_voucher_disable="id_voucher_disable"
                               :type="FLASH_SALE"
                               :vouchers="allCode[FLASH_SALE]"
                               @setListVoucherForContract="setListVoucherForContract" @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[PERIODIC_PROMOTIONS]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình định kỳ</h1>
                <list-vouchers :allCode='allCode'
                               :loading_voucher="loading_voucher"
                               :colorCode="'#1BC5BD'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="PERIODIC_PROMOTIONS"
                               :vouchers="allCode[PERIODIC_PROMOTIONS]"
                               @setListVoucherForContract="setListVoucherForContract" @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[SCHOOL_LINK]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình liên kết trường</h1>
                <list-vouchers :allCode='allCode'
                               :loading_voucher="loading_voucher"
                               :colorCode="'#3343D0'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="SCHOOL_LINK"
                               :vouchers="allCode[SCHOOL_LINK]"
                               @setListVoucherForContract="setListVoucherForContract" @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[OTHER_SCHOOL]?.length" class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình khác</h1>
                <list-vouchers :allCode='allCode'
                               :loading_voucher="loading_voucher"
                               :colorCode="'#D40000'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="OTHER_SCHOOL"
                               :vouchers="allCode[OTHER_SCHOOL]"
                               @setListVoucherForContract="setListVoucherForContract" @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[DIGITAL]?.length && +contract?.get_ma_gioi_thieu?.profile?.chi_nhanh_id === digitalBranch"
                 class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình Digital</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#0094ff'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="DIGITAL"
                               :vouchers="allCode[DIGITAL]"
                               @setListVoucherForContract="setListVoucherForContract" @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[SUSPENSION]?.length"
                 class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình bảo lưu</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#7C3AED'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="SUSPENSION"
                               :vouchers="allCode[SUSPENSION]"
                               @setListVoucherForContract="setListVoucherForContract"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <div v-if="allCode[LEARNING_GUARANTEE]?.length"
                 class="mt-5">
                <h1 style="font-size: 14px;font-weight: bold;text-align: left">Chương trình bảo hành</h1>
                <list-vouchers :allCode='allCode'
                               :colorCode="'#2563EB'"
                               :id_voucher_disable="id_voucher_disable"
                               :type="LEARNING_GUARANTEE"
                               :vouchers="allCode[LEARNING_GUARANTEE]"
                               @setListVoucherForContract="setListVoucherForContract"
                               @showVoucherDetail="showVoucherDetail"
                >
                </list-vouchers>
            </div>
            <b-button ref="show-voucher-detail" v-b-modal.voucher-detail hidden size="sm">Open Third Modal</b-button>
        </b-modal>

        <!-- Chi tiết mã giảm giá -->
        <b-modal id="promotion-detail" ref="modal-promotion-detail" :centered="true" :scrollable="true" hide-footer
                 size="lg" title="Chi tiết mã giảm giá">
            <promotion-detail
                :gift_select="gift_select"
                :promotion="promotion_detail"
            ></promotion-detail>
        </b-modal>

        <!-- Chi tiết voucher -->
        <b-modal id="voucher-detail" ref="modal-promotion-detail" :centered="true" :scrollable="true" hide-footer
                 size="lg"
                 title="Chi tiết voucher">
            <voucher-detail :voucher="voucher_detail"></voucher-detail>
        </b-modal>

        <!-- Nạp rút tặng quà -->
        <b-modal ref="modal-nap-rut" :centered="true" :scrollable="true" class="modal-nap-rut" hide-footer size="xl"
                 title="Nạp - rút - tặng quà" @hide="onHide">
            <div class="d-block text-center">
                <div class="row">
                    <div class="col-md-7">
                        <user-detail
                            ref="formChild"
                            :branch="contract_detail.branch"
                            :center="contract_detail.center"
                            :customer="contract_detail.customer"
                            :detail="contract_detail"
                            :is_disable_mail="disableEmail"
                            :is_disable_phone="disablePhone"
                            :is_edutalk="is_edutalk"
                            :totalPaid="contract_detail.total_paid"
                            :tuitionPayments="tuitionPayments"
                            :user="contract_detail.user"
                        ></user-detail>
                        <div v-if="is_edutalk" class="row col-md-6">
                            <div class="form-group">
                                <label>Hình thức đóng học phí<span class="text-danger"></span></label>
                                <el-select v-model="tuitionPayment" class="w-100" disabled
                                           placeholder="Hình thức đóng học phí">
                                    <el-option
                                        v-for="item in tuitionPayments"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-card active-nav-item-class="font-weight-bold text-uppercase text-danger"
                                    active-tab-class="font-weight-bold text-success" class="nap_rut_all_form">
                                <b-tabs card pills>
                                    <!-- Tab Nạp tiền -->
                                    <b-tab active title="Nạp tiền">
                                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                            <form class="form" @submit.prevent="handleSubmit(depositMoney)">
                                                <div class="row">
                                                    <div class="col-md-12 d-lg-flex">
                                                        <div class="col-form-label checkbox-inline">
                                                            <label class="checkbox checkbox-success">
                                                                <input v-model="type" name="Checkboxes5"
                                                                       type="checkbox">
                                                                <span></span>Khách hàng nợ</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Số tiền nạp: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider
                                                                v-slot="{ errors, classes }"
                                                                mode="lazy"
                                                                name="Số tiền nạp"
                                                                rules="excluded:0|min_value:1"
                                                                vid="deposit_money"
                                                            >
                                                                <money v-model="amount" :class="classes"
                                                                       class="form-control" v-bind="money"/>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Hình thức thanh toán: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                name="Hình thức thanh toán"
                                                                                rules="required"
                                                                                vid="refund_note">
                                                                <el-select v-model="hinh_thuc_thanh_toan"
                                                                           class="w-100 test-id" clearable filterable
                                                                           name="refund_note"
                                                                           placeholder="Chọn hình thức thanh toán">
                                                                    <el-option
                                                                        v-for="item in hinh_thuc_thanh_toans"
                                                                        :key="item.name"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.name"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="refund_note"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                    <div v-if="showInputInstallment && hinh_thuc_thanh_toan == 'Chuyển khoản'"
                                                         class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tài khoản nhận tiền: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                name="Tài khoản nhận tiền"
                                                                                rules="required"
                                                                                vid="refund_note">
                                                                <el-select v-model="typeAccount" class="w-100 test-id"
                                                                           clearable filterable
                                                                           name="refund_note"
                                                                           placeholder="Vui lòng chọn tài khoản nhận tiền">
                                                                    <el-option
                                                                        v-for="item in typeAccounts"
                                                                        :key="item.id"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.id"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="refund_note"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-if="showInputInstallment && (hinh_thuc_thanh_toan == 'Quẹt thẻ' || (hinh_thuc_thanh_toan == 'Chuyển khoản' && tuitionPayment == 5))"
                                                        class="col-md-6">
                                                        <div class="form-group">
                                                            <label v-if="hinh_thuc_thanh_toan == 'Quẹt thẻ'">Mục đích
                                                                quẹt thẻ : <span class="text-danger">*</span></label>
                                                            <label v-if="hinh_thuc_thanh_toan == 'Chuyển khoản'">Mục
                                                                đích thanh toán trả góp : <span
                                                                    class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                name="Mục đích quẹt thẻ"
                                                                                rules="required"
                                                                                vid="type_card">
                                                                <el-select v-model="type_card"
                                                                           class="w-100 test-id" clearable
                                                                           filterable
                                                                           name="type_card"
                                                                           placeholder="Chọn mục đích quẹt thẻ"
                                                                           @change="handleInstallment">
                                                                    <el-option
                                                                        v-for="item in type_cards"
                                                                        :key="item.id"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.id"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="type_card"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                    <div v-if="hinh_thuc_thanh_toan == 'Quẹt thẻ' && type_card === 1"
                                                         class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Hình thức thanh toán phí: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider
                                                                v-slot="{ errors, classes }"
                                                                mode="lazy"
                                                                name="Hình thức thanh toán phí"
                                                                rules="required"
                                                            >
                                                                <el-select v-model="payment_method" class="w-100 test-id"
                                                                           clearable name="type_card"
                                                                           placeholder="Chọn hình thức thanh toán phí">
                                                                    <el-option
                                                                        v-for="item in paymentMethods"
                                                                        :key="item.id"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.id"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="text-danger">{{ errors[0] }}</div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="!is_transferred" class="row mt-2">
                                                    <div class="col-md-12">
                                                        <a class="promotion-list" href="javascript:"
                                                           @click="showVouchers">
                                                            <strong>Danh sách voucher</strong>
                                                            <span class="promotion-count">{{ vouchers.length }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div v-if="!is_transferred" class="row mt-8">
                                                    <div class="col-12 col-md-12">
                                                        <div v-for="(voucher,index) in vouchersForContract" :key="index"
                                                             class="row">
                                                            <div class="col-2">
                                                                <p>Voucher {{ ++index }}:</p>
                                                            </div>
                                                            <div class="col-7">
                                <span class="promotion-icon"><i class="fas fa-minus-circle mr-2"
                                                                style="cursor: pointer;"
                                                                @click="removeContractVoucher(index)"></i></span>
                                                                <span class="promotion-list"><strong>{{
                                                                        voucher.name
                                                                    }}</strong></span>
                                                            </div>
                                                            <div class="col-3">
                                                                <strong v-if="voucher.unit === 1 "
                                                                        class="text-danger">{{
                                                                        voucher.value | toThousandFilter
                                                                    }} ₫</strong>
                                                                <strong v-else class="text-danger">{{ voucher.value }}
                                                                    %</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 mt-3 text-lg-right btn-witdh"
                                                         style="text-align: center">
                                                        <button :disabled="is_disable" class="btn btn-success"
                                                                type="submit">Nạp tiền
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </b-tab>
                                    <!-- Tab Rút tiền -->
                                    <b-tab title="Rút tiền">
                                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                            <form class="form" @submit.prevent="handleSubmit(withdrawMoney)">
                                                <div v-if="is_cancel_course" class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Rút cho khóa học <span class="text-danger"> *</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }" name="Khóa học"
                                                                                rules="required"
                                                                                vid="withdraw_course">
                                                                <multiselect v-model="withdraw_course"
                                                                             :class="classes"
                                                                             :close-on-select="true"
                                                                             :options="condition_courses"
                                                                             label="name"
                                                                             multiple
                                                                             placeholder="Chọn Khóa Học"
                                                                             track-by="name"
                                                                ></multiselect>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="withdraw_course"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Số tiền rút: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                mode="lazy"
                                                                                name="Số tiền rút"
                                                                                rules="required|excluded:0|min_value:1"
                                                                                vid="withdraw_money">
                                                                <money v-model="withdraw_money" :class="classes"
                                                                       class="form-control" name="value"
                                                                       v-bind="money"
                                                                ></money>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="name"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Số tiền quà:</label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                mode="lazy"
                                                                                name="Số tiền quà"
                                                                                rules="min_value:0"
                                                                                vid="withdraw_gift_money">
                                                                <money v-model="withdraw_gift_money" :class="classes"
                                                                       class="form-control" name="gift_amount"
                                                                       v-bind="money"
                                                                ></money>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="gift_amount"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>

                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Lý do rút: <span class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }" name="Lý do rút"
                                                                                rules="required"
                                                                                vid="reason">
                                                                <el-select v-model="reason" class="w-100 test-id" clearable
                                                                           filterable name="reason"
                                                                           placeholder="Chọn hình lý do rút"
                                                                           @change="changeReason">
                                                                    <el-option
                                                                        v-for="item in listReason"
                                                                        :key="item.id"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.id"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="refund_note"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                        <div class="form-group mb-0">
                                                            <label class="mb-0">Xuất hoá đơn thuế</label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                mode="lazy"
                                                                                name="Số tiền quà"
                                                                                rules="min_value:0"
                                                                                vid="withdraw_gift_money">
                                                                <div class="mt-2">
                                                                    <el-switch
                                                                        v-model="is_tax_invoice"
                                                                        :active-value="true"
                                                                        :inactive-value="false"
                                                                    />
                                                                </div>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="gift_amount"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                    <div v-if="checkReason" class="col-md-6">
                                                        <div class="form-group">

                                                            <label>Chi tiết lý do: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }" name="Chi tiết lý do"
                                                                                rules="required"
                                                                                vid="reason">

                                <textarea v-model="withdraw_reason" class="form-control w-100" maxlength="50"
                                          rows="3"></textarea>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="name"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button :disabled="is_disable" class="btn btn-success text-right"
                                                                type="submit">Rút tiền
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </b-tab>
                                    <!-- Tab Tặng Quà -->
                                    <b-tab v-if="!is_edutalk" title="Tặng quà">
                                        <ValidationObserver ref="gift-form" v-slot="{ handleSubmit }">
                                            <form id="giftForm" class="form" @submit.prevent="handleSubmit(submitGift)">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Quà tặng hiện vật: <span class="text-danger"></span></label>
                                                            <input v-model=gift_name class="form-control" name="name"
                                                                   placeholder="Nhập quà tặng"
                                                                   type="text">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tặng tiền mặt: <span
                                                                class="text-danger"></span></label>
                                                            <!--                                  <ValidationProvider name="Số tiền tặng" rules="min_value:0" mode="lazy" v-slot="{ errors,classes }" vid="value">-->
                                                            <money v-model="gift_money" class="form-control" name="value"
                                                                   v-bind="money"></money>
                                                            <!--                                    <div class="fv-plugins-message-container">-->
                                                            <!--                                      <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }} </div>-->
                                                            <!--                                    </div>-->
                                                            <!--                                  </ValidationProvider>-->
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Lý do tặng quà: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }" name="Lý do tặng quà"
                                                                                rules="required"
                                                                                vid="reason">
                                                                <input v-model=gift_reason :class="classes" class="form-control"
                                                                       name="name"
                                                                       placeholder="Nhập lý do tặng quà"
                                                                       type="text">
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="name"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button :disabled="is_disable" class="btn btn-success"
                                                                type="submit">Tặng
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </b-tab>
                                    <!-- Tab Hoàn tiền -->
                                    <b-tab title="Hoàn tiền">
                                        <ValidationObserver ref="refund-form" v-slot="{ handleSubmit }">
                                            <form id="refundForm" class="form"
                                                  @submit.prevent="handleSubmit(submitRefund)">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Nhập số tiền hoàn: <span class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }"
                                                                                mode="lazy"
                                                                                name="Số tiền hoàn" rules="required|excluded:0|min_value:1"
                                                                                vid="value">
                                                                <money v-model="refund_money" class="form-control"
                                                                       name="value" v-bind="money"></money>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block" data-field="name"
                                                                         data-validator="notEmpty">{{
                                                                            errors[0]
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Chương trình: <span
                                                                class="text-danger">*</span></label>
                                                            <ValidationProvider v-slot="{ errors,classes }" name="Chương trình"
                                                                                rules="required"
                                                                                vid="refund_note">
                                                                <el-select v-model="refund_note" class="w-100 test-id"
                                                                           clearable filterable
                                                                           name="refund_note"
                                                                           placeholder="Chọn chương trình">
                                                                    <el-option
                                                                        v-for="item in listRefundByBranch"
                                                                        :key="item.id"
                                                                        :class="classes"
                                                                        :label="item.name"
                                                                        :value="item.name"
                                                                    >
                                                                        <span style="float: left">{{ item.name }}</span>
                                                                    </el-option>
                                                                </el-select>
                                                                <div class="fv-plugins-message-container">
                                                                    <div class="fv-help-block"
                                                                         data-field="refund_note"
                                                                         data-validator="notEmpty">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 text-right">
                                                        <button :disabled="is_disable" class="btn btn-success"
                                                                type="submit">Hoàn
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                    </div>
                    <div class="col-md-5 mt-lg-0 mt-3 shadow">
                        <payment-detail-nap-rut-form :contract="contract_detail"
                                                     :course-price="coursePrice"
                                                     :hide-course-price-edit="isCourseType77Contract"
                                                     :courses-refund="coursesRefund"
                                                     :gift_select="gift_select"
                                                     :is-transferred="is_transferred"
                                                     :is-withdraw-with-course="isWithdrawWithCourse"
                                                     :is_edutalk="is_edutalk"
                                                     :promotion-for-contract="promotionForContract"
                                                     :promotions="promotions"
                                                     :tong-khuyen-mai-sau-huy="tongKhuyenMaiSauHuy"
                                                     :total-contract-amount="totalContractAmount"
                                                     :total-course-refund-fee="totalCourseRefundFee"
                                                     :total-course-register-fee="totalCourseRegisterFee"
                                                     :total-destroy-fee="totalDestroyFee"
                                                     :total-discount="totalDiscount"
                                                     :total-promotion-after-transferred="totalPromotionAfterTransferred"
                                                     :vouchers="vouchers"
                                                     :vouchers-for-contract="vouchersForContract"
                                                     @changeCoursePrice="changeCoursePrice"
                                                     @changeDestroyFee="changeDestroyFee"
                        ></payment-detail-nap-rut-form>
                        <div class="payment-information">
                            <payment-information :gift-data="giftData" :is_edutalk="is_edutalk"
                                                 :refund-data="refundData" :subcontracts="contract_detail.subcontracts"></payment-information>
                        </div>
                    </div>
                </div>
            </div>
            <b-button ref="show-vouchers-list" v-b-modal.list-vouchers hidden size="lg">Open Third Modal</b-button>
        </b-modal>
        <program-create :show-modal="showModalProgram" @clicked="closeModalProgram"
                        @programCreateSuccess="programCreateSuccess"></program-create>
        <!-- <div>
          <b-modal id="bv-modal-example" hide-footer>
            <template #modal-title>
              Thông báo
            </template>
            <div class="d-block text-center">
              <p>{{titleNoti}}</p>
            </div>
            <div class="d-block text-center">
              <p>Bạn vui lòng hướng dẫn khách hàng viết Đơn đề xuất học theo nguyện vọng.</p>
            </div>
            <div class="d-flex justify-content-center">
              <router-link
                  v-if="checkTestInput"
                  class="border border-violet p-2 rounded mr-2 text-dark"
                  :to="{ name: 'customer-crm-detail', params: { id : dataUserCustomer.id }, query: {best_customer_id: dataUserCustomer.best_customer ? dataUserCustomer.best_customer.id : ''}}"
              >Xem kết quả test
              </router-link>
              <button class="bg-violet text-white px-6 py-2 rounded" block @click="$bvModal.hide('bv-modal-example'), understood = true">Đã hiểu</button>
            </div>
          </b-modal>
        </div> -->
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import CourseClass from "./CourseClass";
import ProgramCreate from "./modal-contract/ProgramCreate";
import vueCheckboxToggle from 'vue-checkbox-toggle';
import PaymentInformation from "./modal-contract/PaymentInformation";
import ListVouchers from "./modal-contract/ListVouchers";
import ListPromotions from "./modal-contract/ListPromotions";
import PromotionDetail from "./modal-contract/PromotionDetail";
import VoucherDetail from "./modal-contract/VoucherDetail";
import UserDetail from "./modal-contract/UserDetail";
import PaymentDetail from "./modal-contract/PaymentDetail";
import PaymentDetailNapRutForm from "./modal-contract/PaymentDetailNapRutForm";
import {
    GET_PROMOTIONS_BY_CONTRACT,
    GET_VOUCHERS_BY_CONTRACT,
    LIST_GIFT
} from "@/core/services/store/contract/promotions.module";
import {
    DEPOSIT_MONEY,
    GET_REASON_WITHDRAWAL,
    LIST_COURSE_REFUND,
    LIST_WARRANTY_SERVICE,
    NOT_DONE,
    UNDUPLICATED,
    UPDATE_CONTRACT_BEFORE_DEPOSIT,
    WITHDRAW_MONEY
} from "@/core/services/store/contract/contracts.module";
import {GET_TUITION_PAYMENT} from "@/core/services/store/installment/installment.module";
import Swal from "sweetalert2";
import {Money} from 'v-money';
import {CREATE_REFUND} from "@/core/services/store/contract/studentAmount.module";
import '@/assets/sass/custom/tai-chinh/contractForm.scss';
import {GET_COURSES} from "@/core/services/store/course/course.module";
import {mapGetters} from "vuex";
import {LIST_CONTRACT_PROGRAMS} from "@/core/services/store/contract/contract-program.module";
import "@/assets/sass/contract/contractForm.scss";
import ListGifts from "@/view/pages/business/modal-contract/ListGifts";
import {
    DIGITAL,
    FLASH_SALE,
    OTHER_SCHOOL,
    PERIODIC_PROMOTIONS,
    SCHOOL_LINK,
    SUSPENSION,
} from "@/core/option/contractOption";
import {CodeModel} from "@/view/pages/contracts/CodeModel/code";
import {GET_LIST_BRANCHES} from "../../../core/services/store/center/branch.module";
import {paymentMethods} from "../../../common/define";
import {LEARNING_GUARANTEE} from "../../../core/option/contractOption";
import {TYPE_VOUCHER} from "@/core/option/promotionOption";
import {isWarrantyServiceCenter} from "@/core/config/center/centerOption";
import {GET_REGISTER_COURSES_BY_USER} from "@/core/services/store/contract/student-register-course.module";
import {GET_USER_MAIN_CLASSES_DEPOSIT_REFUND} from "@/core/services/store/deposit-refund/depositRefund.module";
import WarrantySelect from "../contracts/WarrantySelect.vue";

const _ = require('lodash');

const COURSE_TYPE_FIXED_TOTAL = 77;
const FIXED_CONTRACT_TOTAL = 200000;
const MAX_COURSE_TYPE_77 = 2;

const LEGACY_WARRANTY_SERVICE = {
    id: null,
    name: "Chính sách bảo hành cũ",
    percent: 0,
    hideCost: true,
};

export default {
    components: {
        ListGifts,
        ProgramCreate,
        Multiselect,
        CourseClass,
        Money,
        vueCheckboxToggle,
        PaymentInformation,
        ListPromotions,
        ListVouchers,
        PromotionDetail,
        VoucherDetail,
        UserDetail,
        PaymentDetail,
        PaymentDetailNapRutForm,
        WarrantySelect
    },
    props: {
        showModal: {default: false},
        contract: {
            type: Object,
            default() {
                return {}
            }
        },
        fromPage: {
            type: String,
            default: () => {
                return ''
            }
        },
        editBranch: {default: false},
        editName: {default: false},
        editEmail: {default: false},
        editPhone: {default: true},
        editBirthDate: {default: false},
        updateContract: {default: false},
        listRefundByBranch: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    name: "ContractForm",
    data() {
        return {
            is_change_promotion: false,
            is_show_promotions: false,
            is_disable: false,
            is_cancel_course: false,
            isWithdrawWithCourse: false,
            checkTotal: false,
            totalRootDiscount: 0,
            totalCourseRefundFee: 0,
            totalDestroyFee: 0,
            totalContractAmount: 0,
            totalWithdrawWithinCourse: 0,
            totalCourseRegisterFee: 0,
            tongKhuyenMaiSauHuy: 0,
            title: '',
            center_classes: [],
            coursesRefund: [],
            courses: [],
            coursePrice: [],
            center_id: '',
            /* recalculate when action */
            recalculate: 1,
            recalculateSubTotal: 1,
            check_general: false,
            disablePhone: false,
            disableEmail: true,
            hinh_thuc_thanh_toan: '',
            edit_branch: null,
            hinh_thuc_thanh_toans: [
                {
                    name: 'Tiền mặt',
                },
                {
                    name: 'Chuyển khoản'
                },
                {
                    name: 'Quẹt thẻ'
                }
            ],
            type_cards: [
                {
                    name: 'Trả góp',
                    id: 1,
                },
                {
                    name: 'Trả thẳng',
                    id: 2,
                }
            ],
            typeAccounts: [
                {
                    name: 'Cá nhân',
                    id: 1,
                },
                {
                    name: 'Công ty',
                    id: 2,
                }
            ],
            /* detail variable */
            contract_detail: {},
            promotion_detail: {},
            voucher_detail: {},
            /* list variable */
            promotions: [],
            vouchers: [],
            /* list variable of contract */
            promotionForContract: '',
            vouchersForContract: [],
            /* condition variable */
            id_promotion_disable: '',
            id_voucher_disable: [],
            condition_courses: [],
            /* calculate variable  */
            totalDiscountByVoucher: 0,
            totalValueOfVoucher: 0,
            totalDiscount: 0,
            /* nạp rút tặng quà */
            amount: '',
            withdraw_course: [],
            withdraw_reason: '',
            withdraw_money: 0,
            withdraw_gift_money: 0,
            khuyenMaiSauHuy: '',
            congNoSauRut: '',
            withdraw_type: '',
            destroy_fee: 0,
            gift_name: '',
            gift_money: '',
            gift_reason: '',
            type: '',
            refundData: [],
            giftData: [],
            subcontracts: [],
            /* refund variable */
            refund_money: '',
            refund_note: '',
            showModalProgram: false,
            showModalListCourses: false,
            paymentMethods,
            payment_method: null,
            is_tax_invoice: true,
            /* v-money */
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' VNĐ',
                precision: 0,
                masked: false,
            },
            is_installment: '',
            tuitionPayment: '',
            tuitionPayments: [],
            showTuitionPayment: false,
            showInputInstallment: false,
            is_transferred: false,
            totalPromotionAfterTransferred: 0, // tổng khuyến mại sau chuyển nhượng
            listGift: [],
            gift_select: [],
            is_edutalk: false,
            dialogQrCode: false,
            listReason: [],
            reason: '',
            checkReason: false,
            contentReason: '',
            titleNoti: '',
            checkTestInput: true,
            dataUserCustomer: {},
            understood: false,
            SCHOOL_LINK: SCHOOL_LINK,
            FLASH_SALE: FLASH_SALE,
            PERIODIC_PROMOTIONS: PERIODIC_PROMOTIONS,
            OTHER_SCHOOL: OTHER_SCHOOL,
            allCode: {},
            checkGiff: true,
            DIGITAL: DIGITAL,
            LEARNING_GUARANTEE: LEARNING_GUARANTEE,
            SUSPENSION: SUSPENSION,
            digitalBranch: 182,
            typeAccount: null,
            branches: [],
            type_card: '',
            branchs: [],
            needCheckDestroyFee: false,
            isDeletedCourse: false,
            keyword: '',
            loading_voucher: true,
            countVoucherAndGift: 0,
            warrantyServices: [],
            mainClassOptions: [],
            mainClassLoading: false,
        }
    },
    mounted() {
        this.clearForm();
    },
    created() {
      this.queryByKeywordDebounced = _.debounce(this.getListVouchers, 1000);
    },
    computed: {
        ...mapGetters(['getAllPrograms']),
        promotionTotal() {
            if (this.contract?.get_ma_gioi_thieu?.profile?.chi_nhanh_id === this.digitalBranch) {
                return this.vouchers.length + this.listGift.length
            }
            return (this.vouchers.length + this.listGift.length) - (this.allCode[DIGITAL]?.length ?? 0)
        },
        isCourseType77Contract() {
            return (this.contract_detail.student_register_courses || []).some(
                (item) => item.course_id && this.isCourseType77(item)
            );
        },
        availableCourses() {
            let filtered = [];
            if (this.courses?.length) {
                const selected = (this.contract_detail.student_register_courses || []).filter(
                    (item) => item.course_id
                );
                const hasType77 = selected.some((item) => this.isCourseType77(item));
                const hasOther = selected.some(
                    (item) => item.course_id && !this.isCourseType77(item)
                );

                if (hasType77) {
                    filtered = this.courses.filter((item) => this.isCourseType77(item));
                } else if (hasOther) {
                    filtered = this.courses.filter((item) => !this.isCourseType77(item));
                } else {
                    filtered = this.courses;
                }
            }
            return this.mergeSelectedCoursesIntoOptions(filtered);
        },
        type77SelectedCount() {
            return this.countType77Courses();
        },
        showMainClassSelect() {
            return this.isCourseType77Contract && this.type77SelectedCount >= 1;
        },
        canAddMoreCourse() {
            if (!this.isCourseType77Contract) {
                return true;
            }
            return (
                this.type77SelectedCount < MAX_COURSE_TYPE_77 &&
                (this.contract_detail.student_register_courses || []).length < MAX_COURSE_TYPE_77
            );
        },
    },
    watch: {
        showModal() {
            if (this.showModal) {
              this.keyword = '';
              if (!this.updateContract) {
                    this.title = "Nạp - rút - tặng quà";
                } else {
                    this.title = "Sửa hợp đồng";
                    this.needCheckDestroyFee = true;

                }

                if (this.contract) {
                    // Chuẩn hóa: gift_select luôn là mảng
                    const origGift = this.contract.gift_select;
                    const selectedArray = Array.isArray(origGift)
                        ? origGift
                        : (origGift ? [origGift] : []);
                    this.gift_select = selectedArray.map(g => ({
                      ...g,
                      description: g?.description?.replace(/\n/g, '<br>')
                    }));
                    if (!Array.isArray(this.contract.gift_id)) {
                      this.contract.gift_id = selectedArray.map(g => g.id);
                    }
                    this.center_id = this.contract.center_id;
                    this.tuitionPayment = this.contract.tuition_payment != null ? this.contract.tuition_payment.id : '';

                    this.showInputInstallment = false;
                    this.disableEmail = true;
                    this.is_edutalk = false;
                    if (this.contract.center && this.contract.center.is_edutalk === 1) {
                        this.showInputInstallment = true
                        this.disableEmail = false;
                        this.is_edutalk = true
                    }
                    this.getCourses();
                    this.getListProgram();
                    this.listCourseRefund();
                    this.checkOpenModal();
                    this.getTuitionPayments();
                    if (this.fromPage === 'nap-rut') {
                        this.disablePhone = true;
                    }
                    if (this.fromPage === 'danh-sach-hd') {
                        this.showTuitionPayment = true
                    }
                    // set các giá trị cho việc hiển thị
                    this.contract_detail = this.contract;
                    this.contract_detail.is_change_promotion = false
                    this.getListBranch();
                    this.refundData = this.contract_detail.log_refund.filter((item) => {
                        return item.type_refund === 4;
                    });
                    this.giftData = this.contract_detail.log_refund.filter((item) => {
                        return item.type_refund === 3;
                    });
                    this.subcontracts = this.contract_detail.subcontracts;
                    if (this.contract_detail && this.contract_detail.user && this.contract_detail.user.profile) {
                        this.contract_detail.user.profile.birthday = this.contract_detail.user.profile.birthday ?
                            this.contract_detail.user.profile.birthday.split("-").reverse().join("-") : '';
                    }
                    this.contract_detail.user.profile.birthday = this.contract_detail.user.profile.birthday ?
                        this.contract_detail.user.profile.birthday.split("-").reverse().join("-") : '';
                    const subcontractsCourse = this.contract_detail.subcontracts.filter((item) => item.type === 1);
                    //Xử lý những khóa học đã được rút
                    let arrCourse = [];
                    let courseWithDraw = subcontractsCourse.map(item => item.courses_relation).map(item => item.map(item => item.id));
                    courseWithDraw.forEach(item => {
                        item.forEach(value => arrCourse.push(value))
                    })
                    arrCourse = [...new Set(arrCourse)];
                    let courseInCourseStudent = [];
                    this.contract.student_register_courses.forEach((item) => {
                        if (arrCourse.includes(item.course_id)) {
                            courseInCourseStudent.push(item);
                        }
                    });
                    //end
                    //chuyển nhượng
                    this.is_transferred = this.contract_detail.from_course_transfers.length > 0;
                    //end

                    const subcontractsWithinCourse = this.contract_detail.subcontracts.filter((item) => item.type === 2);
                    //nếu là chuyển nhượng
                    if (this.is_transferred) {
                        this.totalCourseRefundFee = courseInCourseStudent.reduce((result, item) => result + (item.course_fee * (100 - item.course_sale) / 100) - item.promotion_fee, 0);
                        this.totalPromotionAfterTransferred = this.contract_detail.total - this.contract_detail.total_after_voucher;
                    } else { // rút tiền bth
                        this.totalCourseRefundFee = courseInCourseStudent.reduce((result, item) => result + (item.course_fee * (100 - item.course_sale) / 100), 0);
                    }
                    this.totalCourseRefundFee = courseInCourseStudent.reduce((result, item) => result + (item.course_fee * (100 - item.course_sale) / 100), 0);
                    // Tổng khuyến mại sau hủy
                    const khuyen_mai_nhung_khoa_da_huy = courseInCourseStudent.reduce((result, item) => result + item.promotion_fee, 0);
                    this.tongKhuyenMaiSauHuy = this.totalDiscount - khuyen_mai_nhung_khoa_da_huy;
                    //end
                    this.totalDestroyFee = this.contract_detail.subcontracts.reduce((result, subcontract) => result + subcontract.destroy_fee, 0);
                    this.totalContractAmount = this.contract_detail.total_after_voucher - this.totalDestroyFee;
                    this.totalCourseRegisterFee = this.contract.student_register_courses.reduce((result, item) => {
                        return result + (item.course_fee * (100 - item.course_sale) / 100)
                    }, 0);
                    this.totalRootDiscount = this.totalCourseRegisterFee - this.totalContractAmount + this.contract_detail.service_total;
                    this.coursePrice = this.contract.student_register_courses.map((item) => item.course_fee);
                    this.promotionForContract = this.contract.vouchers.filter(item => item.type !== 0).shift();
                    let vouchersForContract = [];
                    if (this.promotionForContract) {
                        vouchersForContract.push(this.promotionForContract)
                    }
                    this.contract.vouchers.filter(item => {
                        if (item.type === 0) {
                            vouchersForContract.push(item);
                        }
                    });
                    this.vouchersForContract = vouchersForContract;
                    this.reloadConditionCourses();
                    this.calculateTotalValueForVoucher();
                    this.reloadTotalDiscount();
                    this.id_voucher_disable = this.vouchersForContract.map(item => item.id);
                    this.id_promotion_disable = this.promotionForContract && this.promotionForContract.id;
                    this.getListPromotion();
                    this.getListVouchers();
                    this.getReason();
                    this.syncWarrantyServicesForCenter(this.contract_detail.center_id);
                    if (!this.contract_detail.deposit_refunds) {
                        this.contract_detail.deposit_refunds = {
                            main_class_id: null,
                            main_class_name: "",
                        };
                    }
                    if (this.isCourseType77Contract) {
                        this.applyCourseType77Fees();
                        this.contract_detail.total = FIXED_CONTRACT_TOTAL;
                        this.totalCourseRegisterFee = FIXED_CONTRACT_TOTAL;
                        this.fetchUserMainClasses();
                    }
                }
            }
        },
        isCourseType77Contract(hasType77) {
            if (!hasType77) {
                this.resetDepositRefund();
            } else if (this.contract_detail.user_id || this.contract_detail.user?.id) {
                this.fetchUserMainClasses();
            }
        },
        'contract_detail.user_id'(userId) {
            if (userId && this.isCourseType77Contract) {
                this.fetchUserMainClasses();
            } else {
                this.mainClassOptions = [];
            }
        },
        recalculate() {
            const courses = this.contract_detail.student_register_courses || [];
            if (this.isCourseType77Contract) {
                this.applyCourseType77Fees();
                this.contract_detail.total = FIXED_CONTRACT_TOTAL;
                this.totalCourseRegisterFee = FIXED_CONTRACT_TOTAL;
            } else {
                this.totalCourseRegisterFee = courses.reduce((result, item) => result + (item.fee || 0), 0);
                this.contract_detail.total = _.reduce(
                    courses,
                    function (result, value) {
                        result += value.course_fee * (1 - value.course_sale / 100);
                        return result;
                    },
                    0
                );
            }
            this.recalculateSubTotal++;
        },
        recalculateSubTotal() {
            this.calculateTotalValueForVoucher();
            this.reloadTotalDiscount();
            this.contract_detail.total_after_voucher = this.contract_detail.total - this.totalDiscount + this.totalDestroyFee;
            this.contract_detail.total_debt = this.contract_detail.total_after_voucher - this.contract_detail.total_paid;
            this.totalContractAmount = this.contract_detail.total_after_voucher;
            if (this.contract_detail.total_after_voucher < 0) {
                this.$message.warning('Tiền khóa học phải lớn hơn tiền khuyến mại! Bạn vui lòng thêm khóa học');
                this.checkTotal = true;
            } else {
                this.checkTotal = false;
            }
        },
        contract_detail: {
            handler() {
                if (this.contract_detail.id) {
                    this.coursePrice = this.contract_detail.student_register_courses.map((item) => item.course_fee);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        countType77Courses() {
            return (this.contract_detail.student_register_courses || []).filter(
                (item) => item.course_id && this.isCourseType77(item)
            ).length;
        },
        resetDepositRefund() {
            this.contract_detail.deposit_refunds = {main_class_id: null, main_class_name: ""};
            this.mainClassOptions = [];
        },
        mapMainClassOption(item) {
            const classId = item.id ?? item.class_id ?? item.classes?.id ?? item.classroom_id;
            if (!classId) {
                return null;
            }
            if (item.label) {
                return {
                    id: classId,
                    label: item.label,
                    main_class_name: item.main_class_name ?? item.class_name ?? item.classes?.name ?? item.label,
                    student_register_course_id: item.student_register_course_id ?? null,
                };
            }
            const courseTypeId = Number(
                item.course?.course_type_id ?? item.course_type_id ?? item.course_type
            );
            if (courseTypeId === COURSE_TYPE_FIXED_TOTAL) {
                return null;
            }
            const className = item?.classes?.name ?? item.name ?? "";
            const courseName = item.course?.name ?? item.course_name ?? "";
            const label = className
                ? courseName
                    ? `${className} — ${courseName}`
                    : className
                : courseName || `Lớp #${className}`;
            return {
                id: classId,
                label,
                main_class_name: className || label,
                student_register_course_id: item.id ?? null,
            };
        },
        normalizeMainClassRows(data) {
            if (Array.isArray(data)) {
                return data;
            }
            if (Array.isArray(data?.data)) {
                return data.data;
            }
            return [];
        },
        async fetchUserMainClasses() {
            const userId = this.contract_detail.user_id || this.contract_detail.user?.id;
            if (!userId) {
                this.mainClassOptions = [];
                return;
            }
            this.mainClassLoading = true;
            try {
                let rows = [];
                try {
                    const res = await this.$store.dispatch(GET_USER_MAIN_CLASSES_DEPOSIT_REFUND, {
                        user_id: userId,
                    });
                    if (!res?.error) {
                        rows = this.normalizeMainClassRows(res?.data ?? res);
                    }
                } catch {
                    rows = [];
                }
                if (!rows.length) {
                    const fallback = await this.$store.dispatch(GET_REGISTER_COURSES_BY_USER, {
                        user_id: userId,
                    });
                    if (!fallback?.error) {
                        rows = this.normalizeMainClassRows(fallback?.data ?? fallback);
                    }
                }
                const seen = new Set();
                this.mainClassOptions = rows
                    .map((row) => this.mapMainClassOption(row))
                    .filter((opt) => {
                        if (!opt || seen.has(opt.id)) {
                            return false;
                        }
                        seen.add(opt.id);
                        return true;
                    });
                if (
                    this.contract_detail.deposit_refunds?.main_class_id &&
                    !this.mainClassOptions.some(
                        (opt) => opt.id === this.contract_detail.deposit_refunds.main_class_id
                    )
                ) {
                    this.contract_detail.deposit_refunds.main_class_id = null;
                    this.contract_detail.deposit_refunds.main_class_name = "";
                }
            } finally {
                this.mainClassLoading = false;
            }
        },
        resolveCourseForItem(item) {
            if (!item) {
                return null;
            }
            if (item.course?.course_type_id != null) {
                return item.course;
            }
            const courseId = item.course_id;
            if (!courseId) {
                return item.course ?? null;
            }
            const fromList = (this.courses || []).find((course) => Number(course.id) === Number(courseId));
            return fromList ?? item.course ?? null;
        },
        mergeSelectedCoursesIntoOptions(options) {
            const merged = [...(options || [])];
            const ids = new Set(merged.map((course) => Number(course.id)));
            (this.contract_detail.student_register_courses || []).forEach((item) => {
                if (!item?.course_id) {
                    return;
                }
                const course = this.resolveCourseForItem(item) || item.course;
                const id = Number(course?.id ?? item.course_id);
                if (!id || ids.has(id)) {
                    return;
                }
                const name = course?.name;
                if (!name) {
                    return;
                }
                merged.push({
                    id,
                    name,
                    fee: course.fee ?? item.course_fee,
                    sale: course.sale ?? item.course_sale,
                    course_type_id: course.course_type_id,
                });
                ids.add(id);
            });
            return merged;
        },
        isCourseType77(courseOrItem) {
            const course = courseOrItem?.course_id != null && courseOrItem?.course_type_id == null
                ? this.resolveCourseForItem(courseOrItem)
                : courseOrItem;
            return course && Number(course.course_type_id) === COURSE_TYPE_FIXED_TOTAL;
        },
        applyCourseType77Fees() {
            const type77Courses = (this.contract_detail.student_register_courses || []).filter(
                (item) => item.course_id && this.isCourseType77(item)
            );
            const count = type77Courses.length;
            if (!count) {
                return;
            }
            const perCourse = Math.floor(FIXED_CONTRACT_TOTAL / count);
            const remainder = FIXED_CONTRACT_TOTAL - perCourse * count;
            type77Courses.forEach((item, index) => {
                item.course_fee = perCourse + (index === 0 ? remainder : 0);
                item.fee = item.course_fee * (100 - (item.course_sale || 0)) / 100;
            });
        },
        syncWarrantyServicesForCenter(center_id) {
            if (isWarrantyServiceCenter(center_id)) {
                this.fetchWarrantyServices();
            } else {
                this.warrantyServices = [];
            }
        },
        async fetchWarrantyServices() {
            try {
                const response = await this.$store.dispatch(LIST_WARRANTY_SERVICE);
                const list = Array.isArray(response && response.data) ? response.data : [];
                this.warrantyServices = list.map((item) => ({
                    id: item.id,
                    name: item.name,
                    percent: Number(item.percent_price != null ? item.percent_price : 0),
                })).concat(LEGACY_WARRANTY_SERVICE);
            } catch (error) {
                this.warrantyServices = [];
            }
        },
        setSelectedWarrantyService(service) {
            const percent = Number(service?.percent_price ?? service?.percent ?? 0) || 0;
            const total = Number(this.total ?? this.contract?.total ?? 0) || 0;

            Object.assign(this.contract_detail, {
                service: service ?? null,
                service_id: service?.id ?? null,
                service_total: service ? (total * percent) / 100 : 0,
            });
        },
        deleteGift(gift) {
          if (gift?.program_id && this.allCode[gift.program_id]) {
            this.allCode[gift.program_id] = this.allCode[gift.program_id].map(code =>
                +code.id === +gift.id ? { ...code, selected: false, hidden: false } : code
            )
          }
          this.gift_select = this.gift_select.filter(g => +g.id !== +gift.id);
          if (!Array.isArray(this.contract.gift_id)) this.contract.gift_id = [];
          this.contract.gift_id = this.contract.gift_id.filter(id => +id !== +gift.id);
          this.contract.vouchers = (this.contract.vouchers || []).filter(v => +v.id !== +gift.id);
          this.contract.gift_select = this.gift_select.slice();
          this.checkGiff = this.gift_select.length > 0;
        },
        resetGift() {
          this.contract.gift_id = [];
          this.gift_select = [];
          this.contract.gift_select = [];
        },
        cancelGift(event) {
            this.removeGiftSelected(event.id);
            this.checkGiff = this.gift_select.length > 0;
            let index = this.getIndex(event);
            if (index == null) {
                return;
            }
            this.removeContractVoucher(index + 1);
        },
        getIndex(event) {
            let index = null;
            for (let i = 0; i < this.vouchersForContract.length; i++) {
                let item = this.vouchersForContract[i];
                if (item.id === event.id) {
                    index = i;
                }
            }
            return index;
        },
        pickGift(event) {
          const exists = this.gift_select.some(g => +g.id === +event.id);
          if (!exists) {
            this.gift_select.push(event);
            this.contract.gift_select.push(event);
            this.contract.gift_id.push(event.id);
          }
          if(!this.contract.vouchers.some(g => +g.id === +event.id)) {
            this.contract.vouchers.push(event);
          }
        },
        checkOpenModal() {
            if (this.contract.confirm === 0 || this.updateContract) {
                this.$refs['modal-contract-detail'].show();
                return;
            }

            if (this.contract.center.is_edutalk === 0 && this.contract.total_paid === 0) {
                this.title = "Kiểm tra thông tin hợp đồng";
                this.$refs['modal-contract-detail'].show();
                return;
            }

            this.$refs['modal-nap-rut'].show();
        },
        getTuitionPayments() {
            this.$store.dispatch(GET_TUITION_PAYMENT).then((response) => {
                this.tuitionPayments = response.data
            });
        },
        getListVouchers(branch_id = null) {
            this.$store.dispatch(GET_VOUCHERS_BY_CONTRACT,
                {
                    center_id: this.contract_detail.center_id,
                    branch_id:this.contract_detail.branch_id || branch_id,
                    tuition_payment_id: this.tuitionPayment || this.contract_detail?.tuition_payment_id,
                    quantity_course: this.contract_detail?.student_register_courses?.map((course) => course.course_id).length,
                    course_ids: this.contract_detail?.student_register_courses?.map((course) => course.course_id) ?? [],
                    keyword: this.keyword
                })
                .then((res) => {
                  this.loading_voucher = false;
                  this.vouchers = res.data;
                    this.getListGift()
                });
        },
        getListPromotion(branch_id = null) {
            let courseIds = this.contract_detail.student_register_courses.map(item => item.course_id)
            this.$store.dispatch(GET_PROMOTIONS_BY_CONTRACT,
                {
                    courses: courseIds,
                    center_id: this.contract_detail.center_id,
                    branch_id: branch_id || this.contract_detail.branch_id
                }
            ).then((res) => {
                this.promotions = res.data;
            });
        },
        changeEditBranch(branch_id) {
            this.contract_detail.branch_id = branch_id;
            this.promotionForContract = '';
            this.vouchersForContract = [];
            this.id_voucher_disable = [];
            this.edit_branch = branch_id;
            this.getListVouchers(branch_id);
            this.getListPromotion(branch_id);
            this.recalculate++;
            this.listGift = [];
            this.resetGift();
            this.getListGift();
            this.getCourses();
            this.contract.student_register_courses = [];
        },
        getListGift(type = '') {
            let courseIds = this.contract_detail.student_register_courses ? this.contract_detail.student_register_courses.map(item => item.course_id) : []
            let tuition_payment_id = this.contract.tuition_payment_id;
            if (type === 'change-tuition') {
                tuition_payment_id = this.tuitionPayment;
            }
            this.listGift = [];
            if (this.contract.branch_id) {
                this.$store.dispatch(LIST_GIFT, {
                    'branch_id': this.contract.branch_id,
                    'quantity_course': this.getQuantityCourse(),
                    'tuition_payment_id': tuition_payment_id,
                    'keyword': this.keyword,
                    course_ids: courseIds,
                }).then((response) => {
                    this.listGift = response.data;
                    let giftModel = this.listGift.map((gift) => {
                        return new CodeModel(gift, PERIODIC_PROMOTIONS, true)
                    })
                    let voucherModel = this.vouchers?.map((voucher) => {
                        return new CodeModel(voucher, voucher.program_id)
                    })
                    let ListProgramUsed = this.contract?.vouchers.length === 0 ? (this.contract?.gift_select ? [this.contract?.gift_select.program_id] : []) : this.contract?.vouchers.map((promotion) => promotion.program_id)

                    let code = (voucherModel.concat(giftModel)).map((voucher) => {
                            if (this.contract?.vouchers.find((e) => e.id == voucher.id) || this.contract.gift_id.includes(voucher?.id)) {
                                return {...voucher, selected: true}
                            }
                            voucher.hidden = true;

                        if(((voucher.typeCode !== null )) || ListProgramUsed[0] !== undefined) {
                                voucher.hidden = false;
                            }
                            return voucher
                        }
                    )
                    this.allCode = _.groupBy(code, ({typeCode}) => typeCode)
                });
            }
        },
        getQuantityCourse() {
            return this.total_course = this.contract.student_register_courses.filter((item) => {
                return item.course.id > 0;
            }).length;
        },
        changeEditStatus(status) {
            this.contract_detail.confirm = status;
        },
        showGift() {
            this.$refs['show-gift-list'].click();
        },
        showVouchers() {
            this.keyword = '';
            this.getListVouchers();
            this.$refs['show-vouchers-list'].click();
        },
        showPromotionDetail(promotion) {
            this.promotion_detail = promotion;
            this.$refs['show-promotion-detail'].click();
        },
        showVoucherDetail(voucher) {
            this.voucher_detail = voucher;
            this.$refs['show-voucher-detail'].click();
        },
        setPromotionForContract(promotion) {
            this.recalculateSubTotal += 1;
            this.promotionForContract = promotion;
            this.id_promotion_disable = promotion.id;
            this.$message.success('Áp dụng mã khuyến mại thành công');
            this.$refs['modal-list-promotions'].hide();
        },
        setVoucherForContract(voucher) {
          if (!voucher.amount && voucher.amount != null) {
            this.$message.warning('Voucher bạn chọn đã hết lượt sử dụng');
            return;
          }
          const exists_vouchers = this.contract.vouchers.some(item => item.id === voucher.id);
          if (!exists_vouchers) {
            this.contract.vouchers.push(voucher);
          }
          const exists_contract = this.vouchersForContract.some(item => item.id === voucher.id);
          if (!exists_contract) {
            this.vouchersForContract.push(voucher);
          }

          if (!this.id_voucher_disable.includes(voucher.id)) {
            this.id_voucher_disable.push(voucher.id);
          }
          this.recalculateSubTotal += 1;
        },
        setListVoucherForContract(voucher) {
            this.checkGiff = true;
            this.contract_detail.is_change_promotion = true;
            // this.id_voucher_disable = [];
            this.resetGift();
            if(voucher) {
              this.cancelvoucher(voucher);
            }
            this.totalDiscount = 0
            for (let i = 0; i < Object.values(this.allCode).length; i++) {
              let checkIsType = Object.values(this.allCode)[i].filter((code) => {
                if (code.selected === true) {
                  if (code.isUseGift) {
                    this.pickGift(code);
                  } else {
                    this.setVoucherForContract(code);
                  }
                }
              });
            }
            this.checkGiff = this.gift_select.length > 0;
            this.reloadTotalDiscount()
        },
        removeContractPromotion(index) {
            this.promotionForContract = '';
            this.id_promotion_disable = '';
            this.recalculateSubTotal += 1;
            this.vouchersForContract.splice(index - 1, 1);
            this.id_voucher_disable.splice(index - 1, 1);
            this.contract_detail.is_change_promotion = true;
            this.clearVoucher();
        },
        removeContractVoucher(index) {
            let voucherRemove = this.vouchersForContract[index - 1];
            if (!voucherRemove) {
                return;
            }
            let voucher_id = voucherRemove.id;
            for (let i = 0; i < Object.values(this.allCode).length; i++) {
              Object.values(this.allCode)[i].forEach((code) => {
                if (code.selected === true && code.id == voucher_id) {
                  code.selected = false;
                  code.hidden = false;
                }
              });
            }

            this.amount = this.amount - 1;
            this.recalculateSubTotal += 1;
            this.vouchersForContract.splice(index - 1, 1);
            this.id_voucher_disable = this.id_voucher_disable.filter((id) => +id !== +voucher_id);
            this.contract.vouchers = this.contract.vouchers.filter((item) => +item.id !== +voucher_id);
            this.contract_detail.is_change_promotion = true;
            // Chỉ gỡ đúng quà/voucher vừa hủy, giữ nguyên các quà khác của cùng chương trình
            this.removeGiftSelected(voucher_id);
        },

        // Gỡ 1 quà tặng ra khỏi danh sách đã chọn (không đụng tới các quà còn lại)
        removeGiftSelected(voucherId) {
            if (Array.isArray(this.contract_detail.gift_id)) {
                this.contract_detail.gift_id = this.contract_detail.gift_id.filter((id) => +id !== +voucherId);
            }
            if (Array.isArray(this.contract.gift_id)) {
                this.contract.gift_id = this.contract.gift_id.filter((id) => +id !== +voucherId);
            }
            this.gift_select = (this.gift_select || []).filter((gift) => +gift.id !== +voucherId);
            this.contract.gift_select = this.gift_select.slice();
        },

        cancelvoucher(voucher) {
          let index = this.vouchersForContract.findIndex((item) => +item.id === +voucher.id);
          if (index !== -1) {
            this.removeContractVoucher(index + 1);
          }
          this.contract.vouchers = this.contract.vouchers.filter((item) => +item.id !== +voucher.id);
          this.removeGiftSelected(voucher.id);
        },
        onHide() {
            this.$emit("clicked", true);
            this.gift_reason = '';
            this.gift_money = '';
            this.gift_name = '';
            this.withdraw_money = 0;
            this.withdraw_gift_money = 0;
            this.withdraw_reason = '';
            this.withdraw_course = [];
            this.destroy_fee = 0;
            this.amount = '';
            this.type = '';
            this.hinh_thuc_thanh_toan = '';
            this.type_card = '';
            this.is_installment = '';
            this.is_tax_invoice = true;
        },
        clearForm() {
            this.title = '';
        },
        hideModal() {
            this.$refs['modal-contract-detail'].hide();
        },
        toggleModal() {
            this.$refs['modal-contract-detail'].toggle('#toggle-btn');
        },
        selectClass: function (param) {
            const studentRegisterCourse = this.contract_detail.student_register_courses[param.index];
            studentRegisterCourse.class_id = param.class_id;
        },
        selectCourse: function (param) {
            const course = this.courses.find(item => item.id === param.course_id);
            const studentRegisterCourse = this.contract_detail.student_register_courses[param.index];
            const otherSelected = this.contract_detail.student_register_courses.filter(
                (item, index) => index !== param.index && item.course_id
            );

            if (course && otherSelected.length) {
                const hasType77 = otherSelected.some((item) => this.isCourseType77(item));
                const selectingType77 = this.isCourseType77(course);

                if (hasType77 && !selectingType77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning('Hợp đồng loại khóa này chỉ được chọn các khóa cùng loại');
                    return;
                }
                if (!hasType77 && selectingType77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning('Không thể chọn khóa học này cùng với các khóa học khác loại');
                    return;
                }
            }

            if (course && this.isCourseType77(course)) {
                const otherType77Count = otherSelected.filter((item) =>
                    this.isCourseType77(item)
                ).length;
                if (otherType77Count >= MAX_COURSE_TYPE_77) {
                    studentRegisterCourse.course_id = '';
                    this.$message.warning(
                        `Chỉ được chọn tối đa ${MAX_COURSE_TYPE_77} khóa phí bổ trợ cấp tốc`
                    );
                    return;
                }
            }

            studentRegisterCourse.course_id = param.course_id;
            studentRegisterCourse.chi_nhanh_hoc = param.branch_id;
            let courseSelects = this.contract_detail.student_register_courses
                .filter(item => item.course_id !== '')
                .map(item => item.course_id);
            if (courseSelects.filter((item) => item === param.course_id).length >= 2) {
                studentRegisterCourse.course_id = '';
                this.$message.warning('Bạn không thể chọn 2 khóa học trùng nhau trong cùng 1 hợp đồng');
            } else if (course) {
                studentRegisterCourse.course = course;
                studentRegisterCourse.course_id = course.id;
                studentRegisterCourse.course_sale = course.sale;
                if (this.isCourseType77(course)) {
                    studentRegisterCourse.course_fee = 0;
                    studentRegisterCourse.fee = 0;
                } else {
                    studentRegisterCourse.course_fee = course.fee;
                    studentRegisterCourse.fee = course.fee * (100 - course.sale) / 100;
                }
            }
            this.reloadConditionCourses();
            this.getListVouchers();
            this.getListGift();
            this.recalculate++;
        },
        addCourse() {
            if (!this.canAddMoreCourse) {
                this.$message.warning(
                    `Chỉ được chọn tối đa ${MAX_COURSE_TYPE_77} khóa phí bổ trợ cấp tốc`
                );
                return;
            }
            this.contract_detail.student_register_courses.push({
                contract_id: this.contract.id,
                course_id: '',
                class_id: '',
                course_fee: 0,
                course_sale: 0,
                dang_ky_ho: 0,
                xac_nhan: 1,
                waiting_status: '',
                fee: 0,
                status: 2,
                paid: 0,
                user_id: this.contract_detail.user_id,
                center_id: this.contract_detail.center_id,
                branch_id: this.contract_detail.branch_id,
                center_class: {
                    id: '',
                    course_id: '',
                    name: ''
                },
                course: {
                    id: '',
                    name: '',
                    fee: '',
                    sale: '',
                    course_type_id: '',
                },
                amount: 0
            })
        },
        deleteCourse(indexOrCourseId) {
            this.recalculate++;

            const courses = this.contract_detail.student_register_courses || [];

            if (courses.length <= 1) {
                this.$message.warning('Hợp đồng phải có khóa học');
                return;
            }

            let idx;
            if (Number.isInteger(indexOrCourseId)) {
                idx = indexOrCourseId;
            } else {
                idx = courses.findIndex(c => String(c.course_id) === String(indexOrCourseId));
            }
            if (idx < 0 || idx >= courses.length) {
                this.$message.error('Khóa học không tìm thấy');
                return;
            }

            const courseDelete = courses[idx];
            courses.splice(idx, 1);
            this.reloadConditionCourses();
            this.clearVoucherUseCourse(courseDelete);
        },
        reloadConditionCourses() {
            this.condition_courses = _.reduce(this.contract_detail.student_register_courses, function (result, value, key) {
                result.push({
                    id: value.course.id, name: value.course.name, fee: value.course.fee, sale: value.course.sale,
                });
                return result
            }, []);
        },
        calculateTotalValueForVoucher() {
          this.totalDiscountByVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 0) {
                    result += value.value;
                }
                return result;
            }, 0);
            this.totalValueOfVoucher = _.reduce(this.vouchersForContract, function (result, value, key) {
                if (value.unit === 1) {
                    result += value.value;
                }
                return result;
            }, 0);
        },
        reloadTotalDiscount() {
            if (this.contract_detail.is_change_promotion) {
                if (this.is_transferred) {
                    let totalPromotionTransfer = this.contract_detail.from_course_transfers.reduce((result, item) => result + item.total_promotion_transfer, 0);
                    this.totalDiscount = this.contract_detail.total - this.contract_detail.total_after_voucher - totalPromotionTransfer;
                    return;
                }
                this.totalDiscount = this.totalValueOfVoucher + (this.totalCourseRegisterFee * this.totalDiscountByVoucher / 100);
            } else {
                this.totalDiscount = this.totalRootDiscount;
            }

            let lengthVoucher = this.contract_detail.vouchers.length;
            if(lengthVoucher === 0 || (lengthVoucher === 1 && this.contract_detail.vouchers[0].isUseGift)) {
              this.totalDiscount = 0;
            }
        },
        changeCoursePrice(index) {
            if (this.isCourseType77Contract) {
                return;
            }
            this.contract_detail.student_register_courses[index].course_fee = this.coursePrice[index];
            this.contract_detail.student_register_courses[index].fee = this.coursePrice[index] * (100 - this.contract.student_register_courses[index].course_sale) / 100;
            this.recalculate++;
        },
        changeDestroyFee(index) {
            this.destroy_fee = index;
            this.totalDestroyFee = index;
            this.recalculate++;
        },
        validatePeriodicGift() {
            let allCode = this.allCode || {};
            let giftSelected = Object.keys(allCode).reduce((result, key) => {
                let codes = allCode[key] || [];
                return result.concat(codes.filter((code) => code.selected && +code.type !== TYPE_VOUCHER));
            }, []);
            if (giftSelected.length > 1) {
                this.$message.warning('Chỉ được chọn 1 bộ quà');
                return false;
            }
            return true;
        },
        saveContract() {
            if (!this.validatePeriodicGift()) {
                return;
            }
            if (this.showMainClassSelect && !this.contract_detail.deposit_refunds?.main_class_id) {
                this.$message.warning('Vui lòng chọn lớp học chính');
                return;
            }
            const methodIds = this.contract_detail?.method_payment_id || [];
            if (Array.isArray(methodIds) && methodIds.includes(4)) {
                if (this.contract_detail.onepay_installment == null || this.contract_detail.onepay_installment === '') {
                    this.$message.warning('Vui lòng chọn hình thức trả góp OnePay');
                    return;
                }
                if (!this.contract_detail.onepay_amount || Number(this.contract_detail.onepay_amount) <= 0) {
                    this.$message.warning('Vui lòng nhập số tiền thanh toán OnePay');
                    return;
                }
            }
            if (this.showMainClassSelect) {
                const selectedMainClass = this.mainClassOptions.find(
                    (opt) => opt.id === this.contract_detail.deposit_refunds.main_class_id
                );
                this.contract_detail.deposit_refunds.main_class_name =
                    selectedMainClass?.main_class_name ?? selectedMainClass?.label ?? "";
            } else {
                this.contract_detail.deposit_refunds = null;
            }
            this.is_disable = true;
            this.contract.vouchers = this.vouchersForContract;
            this.contract.total_after_voucher = this.contract_detail.total - this.totalDiscount + this.totalDestroyFee
            this.contract.total_debt = this.contract_detail.total_after_voucher - this.contract_detail.total_paid
            this.contract_detail.voucherIds = this.id_voucher_disable;
            if (this.showTuitionPayment) {
                this.contract_detail.tuition_payment_id = this.tuitionPayment
            }
            if (this.id_promotion_disable) this.id_voucher_disable.push(this.id_promotion_disable);
            if (Array.isArray(this.contract.gift_id) && this.contract.gift_id.length) {
              this.contract_detail.voucherIds = this.contract_detail.voucherIds.filter(
                  id => !this.contract.gift_id.includes(id)
              );
            }
            delete this.contract_detail.created_at
            delete this.contract_detail.updated_at

            this.$refs.form.validate().then(success => {
                if (!success) {
                    return false;
                } else {
                    Swal.fire({
                        title: "Vui lòng kiểm tra kỹ thông tin hợp đồng?",
                        showDenyButton: true,
                        showCancelButton: true,
                        confirmButtonText: "Đồng ý",
                        cancelButtonText: "Không",
                    }).then((result) => {
                        if (this.isWithdrawWithCourse === true && this.totalDestroyFee <= 0 && this.updateContract) {
                            Swal.fire({
                                title: "<div class='destroy-section'>" +
                                    "<h3 >Nhắc nhở</h3>" +
                                    "<hr>" +
                                    "<p>Hợp đồng đã có khoá học bị huỷ mà chưa có phí huỷ khoá.</p>" +
                                    "<i>(Bỏ qua thông báo nếu hợp đồng không cần phí huỷ khoá)</i>" +
                                    "</div>",
                                showConfirmButton: false,
                                showCancelButton: true,
                                customClass: 'destroy_fee',
                                cancelButtonText: "Đã hiểu",
                            }).then((res) => {
                                this.updateContractForm(result)
                            });
                        } else {
                            this.updateContractForm(result)
                        }

                    });
                }
            });
        },

        updateContractForm(result) {
            if (result.isConfirmed) {
                this.contract_detail.branch_id = this.edit_branch || this.contract_detail.branch_id;
                this.$store.dispatch(UPDATE_CONTRACT_BEFORE_DEPOSIT, {
                        id: this.contract.id,
                        params: {...this.contract_detail, ...{destroy_fee: this.totalDestroyFee}}
                    }
                ).then((res) => {
                    this.hideModal();
                    // nếu từ trang nạp rút thì mở popup nạp rút
                    if (this.fromPage === 'nap-rut') {
                        this.contract_detail = res.data;
                        this.$refs['modal-nap-rut'].show();
                    }
                    Swal.fire("Cập nhật thành công", "", "success");
                }).catch((response) => {
                    if (response?.data?.data?.message_validate_form) {
                        this.$refs.form.setErrors(response.data.data.message_validate_form);
                        return;
                    }
                    this.noticeMessage('error', 'Thất bại', response.data?.message);
                }).finally(() => this.is_disable = false)
            }
        },
        actionNotBranch() {
            if (!this.contract_detail.branch_id) {
                this.noticeMessage('error', 'Thất bại', "Không có chi nhánh!");
                return false;
            }
            return true;
        },
        async depositMoney() {
            if (!this.actionNotBranch()) {
                return; // Exit the function if branch ID is not present
            }
            this.contract_detail.amount = this.amount;
            this.contract_detail.voucherIds = this.id_voucher_disable;
            if (this.id_promotion_disable) this.id_voucher_disable.push(this.id_promotion_disable);
            if (Array.isArray(this.contract.gift_id) && this.contract.gift_id.length) {
              this.contract_detail.voucherIds = this.contract_detail.voucherIds.filter(
                  id => !this.contract.gift_id.includes(id)
              );
            }
            this.contract_detail.hinh_thuc_thanh_toan = this.hinh_thuc_thanh_toan;
            this.is_disable = true;
            this.contract_detail.type = this.type ? 3 : 1;
            this.contract_detail.is_installment = this.is_installment;
            this.contract_detail.understood = this.understood;
            this.contract_detail.fee_payment_method = this.payment_method
            this.contract_detail.purpose_of_swiping_card = this.type_card
            this.contract_detail.receiving_account_type = this.typeAccount
            delete this.contract_detail.created_at
            delete this.contract_detail.updated_at
            this.$store.dispatch(DEPOSIT_MONEY, {
                id: this.contract_detail.id,
                params: this.contract_detail
            }).then((res) => {
                this.$emit('deposit');
                this.$refs['modal-nap-rut'].hide();
                this.amount = '';
                this.type = '';
                this.hinh_thuc_thanh_toan = '';
                this.type_card = '';
                this.typeAccount = null
                this.is_installment = ''
                this.payment_method = ''
                this.is_tax_invoice = true;
                this.noticeMessage('success', 'Thành công', res.message);
            }).catch((response) => {
                switch (response.data?.data) {
                    case NOT_DONE:
                        this.titleNoti = 'Khách hàng chưa được kiểm tra test đầu vào!';
                        this.checkTestInput = false;
                        break;
                    default:
                        this.dataUserCustomer = response.data.data;
                        this.titleNoti = 'Khoá học đầu tiên trong hợp đồng của khách hàng không khớp với Khoá học gợi ý khi test đầu vào.';
                        this.checkTestInput = true;
                        break;
                }
                if (response.data?.data == NOT_DONE) {
                    return;
                }
                if (response.data?.data == UNDUPLICATED) {
                    this.$bvModal.show('bv-modal-example')
                    return;
                }
                this.noticeMessage('error', 'Thất bại', response.data?.message);
            }).finally(() => {
                this.is_disable = false;
            });
        },
        withdrawMoney() {
            if (!this.actionNotBranch()) {
                return; // Exit the function if branch ID is not present
            }
            this.withdraw_type = this.withdraw_course.length > 0 ? 1 : 2;
            let courses = this.withdraw_type === 1 ? _.reduce(this.withdraw_course, function (result, value) {
                result.push(value.id);
                return result;
            }, []) : [];
            if (this.is_cancel_course) {
                Swal.fire({
                    title: "Việc rút tiền và hủy khóa sẽ dẫn việc thay đổi giá trị hợp đồng, công nợ khách hàng. Bạn vẫn muốn tiếp tục chứ?",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Đồng ý",
                    cancelButtonText: "Không",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.withdrawFunction(courses);
                    }
                });
            } else {
                this.withdrawFunction(courses);
            }
        },
        withdrawFunction(courses) {
            this.is_disable = true;
            this.$store.dispatch(WITHDRAW_MONEY, {
                value: this.withdraw_money,
                gift_amount: this.withdraw_gift_money,
                is_tax_invoice: this.is_tax_invoice,
                reason: this.withdraw_reason,
                type_reason: this.reason,
                contract_id: this.contract_detail.id,
                type: this.withdraw_type,
                destroy_fee: this.destroy_fee,
                ben_thu_tien: 1,
                courses: courses,
            }).then((res) => {
                this.$refs['modal-nap-rut'].hide();
                this.withdraw_money = '';
                this.withdraw_gift_money = 0;
                this.withdraw_reason = '';
                this.withdraw_course = [];
                this.destroy_fee = '';
                this.noticeMessage('success', 'Thành công', res.message);
            }).catch((response) => {
                if (response?.data?.data?.message_validate_form) {
                    this.$refs['modal-nap-rut'].setErrors(response.data.data.message_validate_form);
                } else {
                    this.noticeMessage('error', 'Thất bại', response.data.message);
                }
            }).finally(() => {
                this.is_disable = false;
                this.is_disable = false;
            });
        },
        disableButtonSave(value) {
            this.checkTotal = value;
        },
        submitGift() {
            if (!this.actionNotBranch()) {
                return; // Exit the function if branch ID is not present
            }
            this.is_disable = true;
            this.$store.dispatch(CREATE_REFUND, {
                id: this.contract_detail.id,
                params: {
                    user_id: this.contract_detail.user_id,
                    type_refund: 3,
                    amount: this.gift_money,
                    note: this.gift_reason,
                    gift: this.gift_name,
                }
            }).then((res) => {
                this.noticeMessage('success', 'Thành công', res.message);
                this.$refs['modal-nap-rut'].hide();
                this.gift_reason = '';
                this.gift_money = '';
                this.gift_name = '';
            }).catch((response) => {
                this.noticeMessage('error', 'Thất bại', response?.data?.message);
            }).finally(() => this.is_disable = false)
        },
        submitRefund() {
            if (!this.actionNotBranch()) {
                return; // Exit the function if branch ID is not present
            }
            this.is_disable = true;
            this.$store.dispatch(CREATE_REFUND, {
                id: this.contract_detail.id,
                params: {
                    user_id: this.contract_detail.user_id,
                    type_refund: 4,
                    amount: this.refund_money,
                    note: this.refund_note,
                    ben_thu_tien: 1,
                }
            }).then((res) => {
                this.noticeMessage('success', 'Thành công', 'Hoàn tiền thành công');
                this.$refs['modal-nap-rut'].hide();
                this.refund_note = '';
                this.refund_money = '';
            }).catch((response) => {
                if (response?.data?.message) {
                    this.noticeMessage('error', 'Thất bại', response.data?.message);
                }
            }).finally(() => {
                this.is_disable = false;
            })
        },
        getCourses: function () {
            this.$store.dispatch(GET_COURSES, {
                limit: 10000,
                status: 1,
                center_id: this.center_id,
                branch_id: this.contract_detail.branch_id,
                all: 1,
        course_branch:1
            }).then((res) => {
                this.courses = _.map(res.data, (item) => ({
                    id: item.id,
                    name: item.name,
                    fee: item.fee,
                    sale: item.sale,
                    course_type_id: item.course_type_id,
                }));
            });
        },
        openModalProgram: function () {
            this.showModalProgram = true;
        },

        closeModalProgram: function () {
            this.showModalProgram = false;
        },

        getListProgram: function () {
            this.$store.dispatch(LIST_CONTRACT_PROGRAMS, {})
                .then(() => {
                })
        },

        programCreateSuccess: function (res) {
            this.refund_note = res.name;
        },

        listCourseRefund: function () {
            this.$store.dispatch(LIST_COURSE_REFUND, {id: this.contract.id})
                .then((res) => {
                    this.coursesRefund = res.data;
                    this.isWithdrawWithCourse = this.coursesRefund.length > 0;
                });
        },
        handleInstallment() {
            if (this.type_card == 1) {
                this.is_installment = true;
            } else {
                this.is_installment = false;
            }
        },
        getReason() {
            this.$store.dispatch(GET_REASON_WITHDRAWAL, {})
                .then((res) => {
                    this.listReason = res.data;

                });
        },
        changeReason() {
            if ([4, 5].includes(this.reason)) {
                this.checkReason = true;
                return;
            }
            this.checkReason = false;
        },
        changeTuitionPayment() {
            this.getListGift('change-tuition');
        },
        clearVoucher() {
            for (let i = 0; i < Object.values(this.allCode).length; i++) {
                Object.values(this.allCode)[i].forEach((item) => {
                    item.selected = false
                    item.hidden = false
                })
            }
            // this.id_voucher_disable = [];
            this.contract_detail.gift_id = [];
            this.contract_detail.id_promotion_disable = '';
            this.id_promotion_disable = '';
            this.gift_select = null;
            this.contract.gift_select = [];
            this.checkGiff = false;
        },
        clearVoucherUseCourse(courseDelete) {
            // const idStr = String(courseDelete.course_id);
            // const removedVoucherIds = [];
            // this.vouchersForContract = this.vouchersForContract.filter(voucher => {
            //     let courses = voucher.course_ids
            //         ? voucher.course_ids.split(',').map(c => c.trim()).filter(c => c !== "")
            //         : [];
            //     if (courses.includes(idStr)) {
            //         removedVoucherIds.push(voucher.id);
            //         return false;
            //     }
            //     return true;
            // });
            // this.id_voucher_disable = this.id_voucher_disable.filter(
            //     id => !removedVoucherIds.includes(id)
            // );
            if (courseDelete.id) {
                this.isWithdrawWithCourse = true;
                this.totalDestroyFee += parseInt((courseDelete.course_fee / this.totalCourseRegisterFee) * this.totalDiscount)
            }
        },

        getListBranch() {
            this.$store.dispatch(GET_LIST_BRANCHES, {
                center_id: this.contract_detail.center_id,
            }).then((res) => {
                this.branches = res.data;
            });
        },
        changeBranch(param) {
            const studentRegisterCourse = this.contract_detail.student_register_courses[param.index];
            studentRegisterCourse.chi_nhanh_hoc = param.branch_id;
        },
        checkPaymentPurpose() {
            return this.showInputInstallment && (this.hinh_thuc_thanh_toan == 'Quẹt thẻ' || (this.hinh_thuc_thanh_toan == 'Chuyển khoản' && this.tuitionPayment == 5))
        }
    },
}
</script>
<style>
.bg-violet {
    background-color: #8950FC;
}

.card-header {
    padding: 16px 15px !important;
}

.border-violet {
    border-color: #8950FC !important;
}

.destroy_fee .swal2-header {
    padding: 0;
}

.destroy_fee .swal2-title {
    margin: 0;
}

.destroy_fee .destroy-section {
    text-align: left;
}

.destroy_fee .destroy-section h3 {
    text-align: left;
}
</style>
